// API base URL
export const BASE_URL =
  process.env.REACT_APP_API_URL || 'https://app.aipolicyscan.com';
// export const BASE_URL =
//   process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Stripe configuration 
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51TGy8C3SPPjL64nHdDapjvYwdcJf7BMiFHYeeNPK1YPXFJRe9xfLNKOX7jzHT29v9V0pFuzgnEsomZx57HP7KU5U00Z7FAMWOp'
